// extracted by mini-css-extract-plugin
export var errorsContainer = "_sl-1";
export var link = "_sl-0";